import { X } from "lucide-react";
import { ENGINE_LABEL, FLOW_ENGINE, LOOPS } from "../../data/flowMvp";

const TONE = { det: "bg-[#E9FBF0] text-[#0a5c2b]", ia: "bg-[#EEF0FF] text-[#3730a3]", mixte: "bg-[#FFF5E0] text-[#8a5a00]" };

/** Simulator: every loop, its numbered flows, their engine, and links. A click plays the flow. */
const LoopMap = ({ titleOf, onPlay, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="loop-map">
    <div className="max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-2xl bg-white p-5 shadow-xl">
      <div className="flex items-center">
        <h2 className="text-lg font-semibold text-[#122118]">Carte des boucles</h2>
        <div className="ml-4 flex gap-1.5 text-[11px]">
          {Object.entries(ENGINE_LABEL).map(([key, label]) => <span key={key} className={`rounded-full px-2 py-0.5 font-semibold ${TONE[key]}`}>{label}</span>)}
        </div>
        <button type="button" onClick={onClose} className="ml-auto rounded-full p-1 hover:bg-gray-100" aria-label="Fermer" data-testid="loop-map-close"><X className="h-5 w-5" /></button>
      </div>
      {LOOPS.map((loop) => (
        <section key={loop.id} className="mt-5" data-testid={`loop-${loop.id}`}>
          <p className="text-sm font-semibold text-[#122118]">{loop.title} <span className="font-normal text-gray-500">· {loop.who}</span></p>
          <div className="mt-2 flex flex-wrap items-center gap-1.5">
            {loop.flows.map((flowId, index) => (
              <span key={`${loop.id}-${index}`} className="flex items-center gap-1.5">
                {index > 0 && <span className="text-gray-400">→</span>}
                <button type="button" onClick={() => onPlay(flowId)} className="rounded-xl border border-gray-200 px-2.5 py-1.5 text-left transition-colors hover:border-[#25D366]" data-testid={`loop-node-${loop.id}-${flowId}-${index}`}>
                  <span className="block text-[12px] font-semibold text-[#122118]">{titleOf(flowId)}</span>
                  <span className={`mt-0.5 inline-block rounded-full px-1.5 text-[10px] font-semibold ${TONE[FLOW_ENGINE[flowId] || "det"]}`}>{ENGINE_LABEL[FLOW_ENGINE[flowId] || "det"]}</span>
                </button>
              </span>
            ))}
          </div>
        </section>
      ))}
      <p className="mt-5 text-[11px] text-gray-500">L’IA propose seulement (lecture, explication, classement d’une phrase). Toute écriture passe par une confirmation et les règles du serveur.</p>
    </div>
  </div>
);

export default LoopMap;
